






























































































































import { defineComponent, reactive, toRefs, onMounted, watch, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { BTable } from 'bootstrap-vue'
import { SearchCondition, Student } from "../../modules/teacher/StudentList"
import { downloadMasterExcel } from "../../modules/teacher/MasterExcelDownload"

export interface Data {
  tabNo: number
  condition: SearchCondition
  students: Student[]
  perPage: number
  totalCount: number
  fields: any[]
  isAllCheckedDelete: boolean
  delete_student_codes: number[]
  isShowPagination: boolean
  isAllDeleteChecked: boolean
  errors: string[]
  isAllCheckedResetLoginFailedCount: boolean,
  reset_login_failed_count_ids: number[],
  isDownloading: boolean,
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 6,
      condition: new SearchCondition(),
      students: new Array<Student>(),
      perPage: 100,
      totalCount: 0,
      fields: [
        {key: "student_code", label: "生徒CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "email", label: "Email(生徒)", sortable: true, class: 'text-center b-table-th-td'},
        {key: "email_parent1", label: "Email(保護者１)", sortable: true, class: 'text-center b-table-th-td'},
        {key: "email_parent2", label: "Email(保護者２)", sortable: true, class: 'text-center b-table-th-td'},
        {key: "course_name", label: "コース", sortable: true, class: 'text-center b-table-th-td'},
        {key: "campus_name", label: "キャンパス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "class_name", label: "クラス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "grade", label: "学年", sortable: true, class: 'text-center b-table-th-td'},
        {key: "kumi", label: "組", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_no", label: "出席番号", sortable: true, class: 'text-center b-table-th-td'},
        {key: "status", label: "在校状態", sortable: true, class: 'text-center b-table-th-td'},
        {key: "login_failed_count", label: "ロック状態", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "150px"}},
        {key: "delete", label: "削除", class: 'text-center', thStyle: {width: "80px"}},
      ],
      isAllCheckedDelete: false,
      delete_student_codes: [],
      isShowPagination: false,
      isAllDeleteChecked: false,
      errors: [],
      isAllCheckedResetLoginFailedCount: false,
      reset_login_failed_count_ids: [],
      isDownloading: false,
    });

    /******************************
     * 検索ボタンクリック
     ******************************/

    const searchButtonClick = async () => {
      state.condition.page = 1;
      await search();
    }

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: any) => x.is_checked = isChecked);
    };

    /******************************
     * 削除
     ******************************/

    const deleteMst = async (): Promise<void> => {

      if(state.students.filter(x => x.is_checked).length == 0){
        alert("削除対象が選択されていません。");
        return;
      }

      if(!window.confirm("削除を実行します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      const delete_ids: number[] = state.students.filter(x => x.is_checked).map(x => x.id);

      await http.post(`/api/teacher/student_list/delete`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = [];
      await http.get(`/api/teacher/student_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.students = response.data.students;
        state.totalCount = state.students.length == 0 ? 0 : state.students[0].full_count;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * ログイン失敗回数リセット
     ******************************/

    const resetLoginFailedCount = async () => {
      if (state.reset_login_failed_count_ids.length == 0) {
        alert('対象の生徒をチェックしてください。');
        return;
      }
      if (!confirm('ログイン失敗回数のリセットを行います。よろしいですか？')) {
        return;
      }
      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/teacher/student_list/reset_login_failed_count`, {ids: state.reset_login_failed_count_ids}).then(response => {
        alert("リセットが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      window.location.reload();
    }

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {

      state.delete_student_codes = [];

      if (newVal) {

        state.delete_student_codes = state.students.map(x => x.student_code);
      }
    });

    watch(() => state.isAllCheckedResetLoginFailedCount, (newVal, oldVal) => {

      state.reset_login_failed_count_ids = [];

      if (newVal) {

        state.reset_login_failed_count_ids = state.students.map(x => x.id);
      }
    });

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {
      if(state.isDownloading){
        return;
      }

      state.isDownloading = true;
      try {
        await downloadMasterExcel(context, {
          apiPath: "student_list",
          condition: state.condition,
          fileName: "生徒マスタ.xlsx",
          confirmMessage: "検索条件に一致する生徒マスタをダウンロードします。よろしいですか？",
          columns: ["student_code", "name", "email", "email_parent1", "email_parent2", "password", "course_code", "campus_code", "class_code", "grade", "kumi", "student_no", "status"],
          deleteColumnCount: 14,
        });
      }
      finally {
        state.isDownloading = false;
      }
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
      state.isShowPagination = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      search,
      clearCondition,
      changePage,
      allSelectChanged,
      deleteMst,
      download,
      searchButtonClick,
      resetLoginFailedCount,
    };
  }
});

